<div class="options-container">
    @for(option of availablePeriods; track $index) {
        <div
            class="option"
            [ngClass]="{'option--selected': option === selectedValue()}"
            (click)="handleValueChange(option)"
            tabindex="0"
            (keydown.enter)="handleValueChange(option)"
            (keydown.space)="handleValueChange(option)"
            [attr.data-cy]="'chart-period-' + option"
        >
            {{ 'charts.periodsSwitch.' + option | translate }}
        </div>
    }
</div>